import { useEffect, useState } from 'react';
// material
import { Button, Container } from '@material-ui/core';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// eslint-disable-next-line import/no-unresolved
import CreateProjectForm from 'src/components/_dashboard/project/CreateProjectForm';
// eslint-disable-next-line import/no-unresolved
import ProjectList from 'src/components/_dashboard/project/ProjectList';

// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getProjectList } from '../../redux/slices/project';
import { getClientList } from '../../redux/slices/client';
import { getVendorList } from '../../redux/slices/vendor';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function Project() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { projectList, disableProjectList, isLoading } = useSelector((state) => state.project);
  const { clientList } = useSelector((state) => state.client);
  const { vendorList } = useSelector((state) => state.vendor);
  const [editId, setEditId] = useState('');
  const [visibleComponent, setVisibleComponent] = useState('List');
  const [currentProject, setCurrentProject] = useState({});
  const [ProjectListStatus, setProjectListStatus] = useState(true);
  const [deleteId, setDeleteId] = useState('');

  useEffect(() => {
    dispatch(getClientList(true));
    dispatch(getVendorList(true));
    dispatch(getProjectList(true));
    dispatch(getProjectList(false));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getProjectList(ProjectListStatus));
  }, [ProjectListStatus]);

  useEffect(() => {
    if (editId) {
      setVisibleComponent('Edit');
      const tempProject = projectList.find((project) => project.id === editId);
      setCurrentProject(tempProject);
    } else setVisibleComponent('List');
  }, [editId]);

  useEffect(() => {
    if (visibleComponent !== 'Edit') setEditId('');
  }, [visibleComponent]);

  useEffect(() => {
    if (editId) setVisibleComponent('Edit');
    else setVisibleComponent('List');
  }, [editId]);

  const setComponentList = (e) => {
    setVisibleComponent('List');
    e.preventDefault();
  };
  return (
    <Page title="Project | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Project"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Project',
              href: PATH_DASHBOARD.general.project,
              handleClick: (e) => {
                setComponentList(e);
              }
            },
            { name: `${visibleComponent} Project` }
          ]}
          action={
            visibleComponent === 'List' ? (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('Create');
                }}
              >
                Add Project
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('List');
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            )
          }
        />
        {visibleComponent === 'Create' && (
          <CreateProjectForm
            CLIENT_OPTION={clientList}
            VENDOR_OPTION={vendorList}
            setVisibleComponent={setVisibleComponent}
          />
        )}
        {visibleComponent === 'List' && (
          <ProjectList
            ProjectListStatus={ProjectListStatus}
            setProjectListStatus={setProjectListStatus}
            projectList={ProjectListStatus ? projectList : disableProjectList}
            setEditId={setEditId}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
            loading={isLoading}
          />
        )}
        {visibleComponent === 'Edit' && (
          <CreateProjectForm
            setVisibleComponent={setVisibleComponent}
            editId={editId}
            currentProject={currentProject}
            CLIENT_OPTION={clientList}
            VENDOR_OPTION={vendorList}
          />
        )}
      </Container>
    </Page>
  );
}
